// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var BALLOT_DATA_KEY = "ballotData";
export var BALLOT_DATA_EXPIRATION_KEY = "ballotDataExpiration";
export var BALLOT_LOCATOR_KEY = "ballotLocatorReference";
export var discardForeignSessionBallotLocator = function (owner) {
    var _a;
    var raw = sessionStorage.getItem(BALLOT_LOCATOR_KEY);
    if (!raw)
        return;
    try {
        var saved = JSON.parse(raw);
        if (((_a = saved === null || saved === void 0 ? void 0 : saved.owner) === null || _a === void 0 ? void 0 : _a.tenantId) === owner.tenantId &&
            saved.owner.eventId === owner.eventId &&
            saved.owner.userId === owner.userId)
            return;
    }
    catch (_b) {
        /* Malformed references cannot belong to an authenticated owner. */
    }
    sessionStorage.removeItem(BALLOT_LOCATOR_KEY);
};
export var readSessionBallotLocator = function (owner, electionId) {
    var _a, _b;
    try {
        var saved = JSON.parse((_a = sessionStorage.getItem(BALLOT_LOCATOR_KEY)) !== null && _a !== void 0 ? _a : "null");
        if (((_b = saved === null || saved === void 0 ? void 0 : saved.owner) === null || _b === void 0 ? void 0 : _b.tenantId) === owner.tenantId &&
            saved.owner.eventId === owner.eventId &&
            saved.owner.userId === owner.userId &&
            !!owner.userId &&
            saved.electionId === electionId &&
            typeof saved.ballotId === "string" &&
            /^(?:[0-9A-HJKMNP-TV-Z]{4}-[0-9A-HJKMNP-TV-Z]{4}|[a-f0-9]{64}|[a-f0-9]{128})$/.test(saved.ballotId))
            return { owner: owner, electionId: saved.electionId, ballotId: saved.ballotId };
    }
    catch (_c) {
        /* Invalid references grant no ballot access. */
    }
    return undefined;
};
export var snapshotSessionBallotData = function () { return ({
    serialized: sessionStorage.getItem(BALLOT_DATA_KEY),
    expiry: sessionStorage.getItem(BALLOT_DATA_EXPIRATION_KEY),
}); };
export var isCurrentSessionBallotData = function (expected) {
    return sessionStorage.getItem(BALLOT_DATA_KEY) === expected.serialized &&
        sessionStorage.getItem(BALLOT_DATA_EXPIRATION_KEY) === expected.expiry;
};
export var clearSessionStorageBallotData = function (expected, locator) {
    if (expected && !isCurrentSessionBallotData(expected))
        return false;
    // Only expiry retains this non-disclosing reference. Logout, successful
    // casting and explicit abandonment clear both pieces of recovery state.
    sessionStorage.removeItem(BALLOT_DATA_KEY);
    sessionStorage.removeItem(BALLOT_DATA_EXPIRATION_KEY);
    if (locator)
        sessionStorage.setItem(BALLOT_LOCATOR_KEY, JSON.stringify(locator));
    else
        sessionStorage.removeItem(BALLOT_LOCATOR_KEY);
    return true;
};
